const WORKOUTS_KEY = 'sm_fitness_workouts';

export function getWorkouts() {
  try {
    return JSON.parse(localStorage.getItem(WORKOUTS_KEY) || '[]');
  } catch {
    return [];
  }
}

export function getWorkoutsByType(type) {
  return getWorkouts().filter((w) => w.type === type);
}

export function getWeekWorkouts() {
  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() - 7);
  return getWorkouts().filter((w) => new Date(w.date) >= cutoff);
}

export function saveWorkout(workout) {
  const workouts = getWorkouts();
  const entry = { ...workout, id: String(Date.now()), createdAt: new Date().toISOString() };
  workouts.unshift(entry);
  localStorage.setItem(WORKOUTS_KEY, JSON.stringify(workouts));
  return entry;
}

export function deleteWorkout(id) {
  const updated = getWorkouts().filter((w) => w.id !== id);
  localStorage.setItem(WORKOUTS_KEY, JSON.stringify(updated));
}

export function getTotalDistance(type) {
  const workouts = type ? getWorkoutsByType(type) : getWorkouts();
  return workouts.reduce((sum, w) => sum + (parseFloat(w.distance) || 0), 0);
}

export function getTotalDuration(type) {
  const workouts = type ? getWorkoutsByType(type) : getWorkouts();
  return workouts.reduce((sum, w) => sum + (parseInt(w.duration) || 0), 0);
}
